export default __webpack_public_path__ + "static/media/IMG_1688.ac2ac2ba.jpeg";